/**
 * Returns a promise that is resolved once the data is fetched
 */

var HTTP_ERROR_MSG = 'HTTP connection error';
var HTTP_WRONG_RESPONSE_MSG = 'Unexpected server response:\n';

/**
 * This method creates an XMLHttpRequest from the provided
 * configuration and requests the data from the backend. The
 * configuration is configured to use OData services.
 *
 * @param {Object} oRequest - Request configuration object
 * @param {string} oRequest.method - References the HTTP method that is used (default: GET)
 * @param {string} oRequest.url - References the resource URL that gets invoked
 * @return {Promise} Returns a Promise that will be resolve once the requested data was fetched
 */
function sendRequest(oRequest) {
	if (typeof oRequest !== 'object' || oRequest === null || typeof oRequest.dataUrl !== 'string') {
		throw new Error('Unable to send request - Mandatory parameters missing.');
	}

	return (oRequest.method === 'BATCH' && oRequest.serviceUrl ? sendBatchRequest : sendGetRequest)(oRequest);
}

/**
 * Creates and sends a GET request to the backend service.
 *
 * @param {Object} oRequest - Request object that contains all necessary information to create the batch request
 * @returns {Promise} - A Promise that resolves in a JSON object containing the fetched data
 */
function sendGetRequest(oRequest) {
	return new Promise(function(fnResolve, fnReject) {
		var sHeaderKey;
		var xhr = new XMLHttpRequest();

		xhr.onload = function() {
			if (this.status >= 400) {
				fnReject(this.responseText);

				return;
			}
			try {
				fnResolve(JSON.parse(this.responseText));
			} catch (e) {
				fnReject(HTTP_WRONG_RESPONSE_MSG + this.responseText);
			}
		};
		xhr.onerror = function() {
			fnReject(HTTP_ERROR_MSG);
		};
		xhr.onabort = function() {
			fnReject(HTTP_ERROR_MSG);
		};
		xhr.open('GET', oRequest.dataUrl, true);
		xhr.setRequestHeader('accept', 'application/json');

		/* Set custom header information on the request as well as on the batch request */
		for (sHeaderKey in oRequest.headers) {
			if (sHeaderKey.toLowerCase() != 'accept') {
				xhr.setRequestHeader(sHeaderKey, oRequest.headers[sHeaderKey]);
			}
		}

		xhr.send();
	});
}

/**
 * Creates a pseudo random GUID. This algorithm is not suitable for
 * cryptographic purposes and should not be used therefore.
 *
 * @returns {string} - Generated GUID
 */
function createGuid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random() * 16 | 0, // Bitwise OR is equivalent to Math.floor() but faster
			v = c === 'x' ? r : ((r & 0x3) | 0x8); // In case of c != 'x', the value is always between 0x8 and 0xB

		return v.toString(16);
	});
}

/**
 * Creates a $batch request and sends it to the backend service.
 *
 * @param {Object} oRequest - Request object that contains all necessary information to create the batch request
 * @returns {Promise} - A Promise that resolves in a JSON object containing the fetched data
 */
function sendBatchRequest(oRequest) {
	return new Promise(function(fnResolve, fnReject) {
		var xhr = new XMLHttpRequest();
		var boundary = 'batch_' + createGuid();
		var getUrl = oRequest.dataUrl.split(oRequest.serviceUrl)[1];
		var body = [];
		var sKey, sValue;

		xhr.onload = function() {
			var responseText, aLines, iEnd, iLength, iStart, oResponseData;

			responseText = this.responseText;
			aLines = this.responseText.split('\r\n');

			// TBD: check return codes
			iStart = 0;
			iLength = aLines.length;
			iEnd = iLength - 1;

			while (iStart < iLength && aLines[iStart].slice(0, 1) !== '{') {
				iStart++;
			}

			while (iEnd > 0 && aLines[iEnd].slice(-1) !== '}') {
				iEnd--;
			}
			aLines = aLines.slice(iStart, iEnd + 1);
			responseText = aLines.join('\r\n');

			try {
				oResponseData = JSON.parse(responseText);
				fnResolve(oResponseData);
			} catch (e) {
				fnReject(HTTP_WRONG_RESPONSE_MSG + responseText);
			}
		};
		xhr.onerror = function() {
			fnReject(HTTP_ERROR_MSG);
		};
		xhr.onabort = function() {
			fnReject(HTTP_ERROR_MSG);
		};

		// Create request
		xhr.open('POST', oRequest.serviceUrl + '$batch', true);

		xhr.setRequestHeader('Accept', 'multipart/mixed');
		xhr.setRequestHeader('Content-Type', 'multipart/mixed;boundary=' + boundary);

		body.push('--' + boundary);
		body.push('Content-Type: application/http');
		body.push('Content-Transfer-Encoding: binary');
		body.push('');
		body.push('GET ' + getUrl + ' HTTP/1.1');

		/* Set header information on the request as well as on the batch request */
		for (sKey in oRequest.headers) {
			sValue = oRequest.headers[sKey];

			if (sKey.toLowerCase() != 'accept') {
				xhr.setRequestHeader(sKey, sValue);
			}
			body.push(sKey + ':' + sValue);
		}

		body.push('');
		body.push('');
		body.push('--' + boundary + '--');
		body.push('');
		body = body.join('\r\n');
		xhr.send(body);
	});
}

module.exports = { sendRequest: sendRequest };


//////////////////
// WEBPACK FOOTER
// ./client/src/provider/RequestHandler.js
// module id = 38
// module chunks = 1